import { useInboxItems } from "@/api/inbox";
import { useAppNavigate } from "@/components/PaneRouter";
import { RecentChats } from "@/components/RecentChats/RecentChats";
import { ROUTES } from "@/constants/routes";
import { route } from "@/utils/route";
import { defaultChatIcon, Title } from "@cohesive/ui-components";

export function Chats() {
  const { data: inboxItems = [] } = useInboxItems(
    {},
    {
      resource_type: "flow-template",
      is_archived: false,
    },
  );

  const appNavigate = useAppNavigate();

  return (
    <>
      <title>Recent Chats</title>

      <div className="flex flex-col items-center justify-center max-w-full">
        <Title
          resourceType="chat"
          title="Recent Chats"
          icon={defaultChatIcon}
          titleClassName="mb-0 flex-col"
          className="items-center"
          readOnly
        />

        <div className="mt-8 page-container">
          <RecentChats
            groupByDate
            inboxItems={inboxItems}
            onFlowSessionClick={(inboxItem) => {
              appNavigate({
                pane: "rightPane",
                to: route(ROUTES.INBOX.ITEM, {
                  inboxItemId: inboxItem.id,
                }),
                options: {
                  state: {
                    allowNewChat: true,
                  },
                },
              });
            }}
          />
        </div>
      </div>
    </>
  );
}
